import { useQuery } from "@apollo/client";
import { TARIFFS_ONE_PROVIDER_CONVERGENT_QUERY } from "Services/queries";

export const useGetProviderConvergentQuery = ({
	displayPrice,
	regionUrl,
	operatorUrl,
	mobileInternet,
	mobileCalls,
	skip,
}) => {
	const convergentQuery = useQuery(TARIFFS_ONE_PROVIDER_CONVERGENT_QUERY, {
		skip,
		variables: {
			price: displayPrice,
			region_url: regionUrl,
			operatorUrl: operatorUrl,
			mobileInternet: mobileInternet,
			mobileCalls: mobileCalls,
		},
	});

	return {
		convergent: convergentQuery.data?.tariffsOneProviderConvergent,
	};
};
